<div
  class="{{
    getStyles()
  }} flex items-center justify-center mb-round px-2 py-1 uppercase whitespace-nowrap"
>
  <span> {{ getStatusText() }} </span>
</div>
